/**
 * フォーム関係-詳細表示用のフォーム
 */
import React, { useMemo } from "react";

import { TFormCategory, TRequiredKey } from "../../../common/components/types";

import { ThemeColorProps } from "../../../../constants/common";

import formStore from "../../../../store/formStore";

import ShowFormGroup from "../molecules/ShowFormGroup";

type Props = {
  formCategory: TFormCategory;
  requiredKey: TRequiredKey;
  colors: ThemeColorProps;
  terminalGridId: number | undefined;
};

const ShowForm: React.FC<Props> = (props: Props) => {
  const { formCategory, requiredKey, colors, terminalGridId } = props;

  const formGroupIds = useMemo(
    () => formStore.getFilteredFormGroupNameIds(formCategory),
    [formCategory]
  );

  return (
    <div>
      {formGroupIds.map((id, index) => (
        <ShowFormGroup
          key={id}
          formGroupNameId={id}
          requiredKey={requiredKey}
          terminalGridId={terminalGridId}
          idx={index}
          colors={colors}
        />
      ))}
    </div>
  );
};

export default ShowForm;
